import {
    SectionCard,
    SectionCardH1,
    SectionCardHeading,
    SectionCardSubH1,
} from '../../../SectionCard';
import { INSTAGRAM_METADATA_BY_KEY } from 'utils/metrics';
import InstagramSortableTopPosts from '../InstagramSortableTopPosts';
import Stack from 'components/Stack';
import TikTokPostsNoDataMessage from '../../../TikTokPostsNoDataMessage';
import TopPostsDownloadButton from '../../TopPostsDownloadButton';
import styled from 'styled-components';
import { useCurrentCountry } from 'utils/hooks';
import { useQuery } from 'react-query';
import { useTopPostsControls } from '../useTopPostsControls.hook';

const Capitalize = styled.span`
    text-transform: capitalize;
`;

const DEFAULT_CARD_METRICS = [
    [INSTAGRAM_METADATA_BY_KEY.last_week_likes, true],
    [INSTAGRAM_METADATA_BY_KEY.total_post_likes, false],
    [INSTAGRAM_METADATA_BY_KEY.wow, false],
    [INSTAGRAM_METADATA_BY_KEY.create_timestamp, false],
];

export const DISPLAY_MODES = {
    CARDS: 'CARDS',
    TABLE: 'TABLE',
};

function InstagramPostsNoDataAppliedFiltersMessage() {
    return <>No posts match the selected filters.</>;
}

function TopPostsSection({
    year,
    week,
    name,
    displayQty = 5,
    perPage = 500,
    tableName = 'top-posts-section',
    cardMetrics = DEFAULT_CARD_METRICS,
    queryFn,
    queryParams,
    ...props
}) {
    const country = useCurrentCountry();
    const {
        sortSelect,
        value,
        defaultSortOption,
        visibleOrderedMetrics,
        columnsMenu,
    } = useTopPostsControls({
        week,
        year,
        mixpanelContext: 'TopPostsSortSelect',
        tableName,
        metrics: cardMetrics,
    });

    const topPostsQuery = useQuery({
        queryKey: [
            'instagram-top-posts',
            {
                ...queryParams,
                year: value.year ? [value.year] : null,
                week: value.week ? [value.week] : null,
                rank_type: [value.apiRankType],
                page: 1,
                per_page: perPage,
            },
        ],
        queryFn: ({ queryKey }) => queryFn({ data: queryKey[1] }),
        enabled: !!(value.year && value.week),
    });

    return (
        <SectionCard>
            <SectionCardHeading {...props}>
                <SectionCardH1>Top Posts</SectionCardH1>
                {name ? (
                    <SectionCardSubH1>
                        for <Capitalize>{name}</Capitalize>
                    </SectionCardSubH1>
                ) : null}
                <div css="margin-left: auto;">
                    <TopPostsDownloadButton
                        year={value.year}
                        week={value.week}
                        name={name}
                        country={country}
                        source="instagram"
                        topPostsQuery={topPostsQuery}
                        visibleOrderedMetrics={visibleOrderedMetrics}
                        csvColumns={[
                            { key: 'url', label: 'Post' },
                            ...visibleOrderedMetrics.map(
                                ({ key, tableHeadColumnLabel: label }) => ({
                                    key,
                                    label,
                                }),
                            ),
                        ]}
                    />
                </div>
            </SectionCardHeading>
            <Stack
                $space=".5rem"
                $direction="row"
                css={`
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                `}
            >
                {sortSelect}
                {columnsMenu}
            </Stack>
            <InstagramSortableTopPosts
                topPostsQuery={topPostsQuery}
                displayQty={displayQty}
                sortOption={defaultSortOption}
                visibleOrderedMetrics={visibleOrderedMetrics}
                NoDataMessage={
                    topPostsQuery
                        ? InstagramPostsNoDataAppliedFiltersMessage
                        : TikTokPostsNoDataMessage
                }
            />
        </SectionCard>
    );
}

export default TopPostsSection;
